import React from 'react'

import {
  StyledWrapper,
  StyledTableWrapper,
  StyledTable,
  StyledThead,
  StyledTbody,
  StyledTh,
  StyledTr,
  StyledTd,
  StyledLinkWrapper,
  StyledDownloadLink,
  StyledButton,
  StyledButtonGroupWrapper,
  StyledButtonContent,
} from './styles'

const ConversionsModalTable = ({
  headers,
  rows,
  templateCSVFile,
  onConfirm1,
  onConfirm2,
  onCancel,
  buttonLabel1 = null,
  buttonLabel2 = null,
  buttonLabel3 = null,
}) => {
  const getHeaders = () =>
    headers.map(({ label, span }, index) => (
      <StyledTh colSpan={span} key={index}>
        {label}
      </StyledTh>
    ))

  const getRow = row =>
    row.map(({ label, isHighlight }, index) => (
      <StyledTd isHighlight={isHighlight} key={index}>
        {label}
      </StyledTd>
    ))

  const getRows = () =>
    rows.map((row, index) => <StyledTr key={index}>{getRow(row)}</StyledTr>)

  return (
    <StyledWrapper>
      <StyledTableWrapper>
        <StyledTable>
          <StyledThead>{getHeaders()}</StyledThead>
          <StyledTbody>{getRows()}</StyledTbody>
        </StyledTable>
      </StyledTableWrapper>
      {(templateCSVFile || buttonLabel1 || buttonLabel2 || buttonLabel3) && (
        <StyledButtonGroupWrapper>
          {buttonLabel1 && (
            <StyledButton onClick={onConfirm1}>
              <StyledButtonContent>{buttonLabel1}</StyledButtonContent>
            </StyledButton>
          )}
          {buttonLabel2 && (
            <StyledButton onClick={onConfirm2}>
              <StyledButtonContent>{buttonLabel2}</StyledButtonContent>
            </StyledButton>
          )}
          {buttonLabel3 && (
            <StyledButton onClick={onCancel}>
              <StyledButtonContent>{buttonLabel3}</StyledButtonContent>
            </StyledButton>
          )}
          {templateCSVFile && (
            <StyledLinkWrapper>
              <StyledDownloadLink {...templateCSVFile}>
                Download error log
              </StyledDownloadLink>
            </StyledLinkWrapper>
          )}
        </StyledButtonGroupWrapper>
      )}
    </StyledWrapper>
  )
}

export default ConversionsModalTable
